import React from "react";
import {useAppSelector} from "./../DAL/store";
import MandatoryOptional from "./mandatory-optional";
import CategoryProductList from "./product-list";
import {SBL_BuilderPageMain} from "../interfaces";
import {LocalEnums} from "../local-enums";

/**
 *  Category
 */
interface ICategoryProps {
    categoryId: number,
    isMandatory:boolean,
    products:SBL_BuilderPageMain[];
    isVisible:boolean;
    index:number;
}
const Category = (props:ICategoryProps) => {

    const UserState_SystemType = useAppSelector((store) => store.UserState_SystemType);
    const UserState_SoftwareWasChosen = useAppSelector((store) => store.UserState_SoftwareWasChosen);
    const ShowProducts = (props.categoryId === LocalEnums.CategoriesIds.Software || UserState_SoftwareWasChosen) && UserState_SystemType.length > 0;
    return (
        <li className="w-full pt-8">
            <div className="flex items-center">
                <div className="text-xl md:text-2xl font-bold">{props.index + ". " + props.products[0].categoryDisplayName}</div>
                {ShowProducts && <MandatoryOptional isMandatory={props.isMandatory}
                                                                   isVisible={props.isVisible}/>
                }
            </div>
            {ShowProducts &&
                <>
                    <div className="py-2 md:w-4/5" dangerouslySetInnerHTML={{ __html: props.products[0].introText }}></div>
                    <CategoryProductList products={props.products} isMandatory={props.isMandatory} />
                </>
            }
            <div className="w-full px-4 border-b pt-8"></div>

        </li>
    );
};

export default Category;
